import { Component, HostListener, output, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MdwButton } from '@spaces-ui/meadow/components/button';
import { MdwListItem } from '@spaces-ui/meadow/components/list-item';
import { Sidebar_Duotone } from '@spaces-ui/meadow/icons/svgs';

@Component({
  imports: [RouterModule, MdwListItem, MdwButton],
  selector: 'app-secondary-sidebar',
  templateUrl: './app-secondary-sidebar.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app-secondary-sidebar.scss',
})
export class AppSecondarySidebar {
  isCollapsed = false;
  isActive = false;
  collapse = output();
  icons = { Sidebar_Duotone };

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  setActive() {
    this.isActive = !this.isActive;
  }

  @HostListener('window:resize', ['$event'])
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected onResize(event: any) {
    if (event.target.innerWidth > 768) {
      this.isCollapsed = false;
    }
  }
}
